/**
 * LOT-UI-02 — Routage intelligent post-login par rôle métier.
 */

export function resolveMagasinRole(user) {
  if (!user) return 'vendeur';
  if (user.magasin_role) return user.magasin_role;
  if (user.username === 'carlos') return 'super_admin';
  if (user.role === 'super_admin' || user.role === 'admin') return 'super_admin';
  if (user.role === 'technicien') return 'technicien';
  return 'vendeur';
}

/** SEC-01 — Administrateur principal Remobiles (`/admin/database`, `/admin/audit`). */
export function isPrimaryAdmin(user) {
  return user?.role === 'admin' && user?.username === 'carlos';
}

/** Admin de magasin (direction ou responsable) — peut accepter/éliminer les lots auto-devis. */
export function isMagasinAdmin(user) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const mr = resolveMagasinRole(user);
  return mr === 'super_admin' || mr === 'admin_magasin';
}

/** SEC-01 — Totaux comptables Hub Activité / ventes (Carlos uniquement). */
export function canViewActiviteFinancialTotals(user) {
  return isPrimaryAdmin(user);
}

/** Destination après connexion staff (hors super_admin plateforme). */
export function getStaffHomeRoute(user) {
  if (!user) return '/login/staff';
  if (user.pos_only) return '/pos-v2';
  if (user.role === 'super_admin' && !user.magasin_role) return '/super-admin';
  const mr = resolveMagasinRole(user);
  if (mr === 'technicien') return '/reparations';
  if (mr === 'vendeur') return '/pos';
  if (mr === 'admin_magasin') return '/dashboard';
  if (mr === 'super_admin') return '/dashboard';
  if (user.role === 'admin') return '/dashboard';
  return '/pos';
}

/** Absent / suspension : accès limité au POS uniquement. */
export function isPosOnlyUser(user) {
  return Boolean(user?.pos_only);
}

/** Routes autorisées pour un compte pos_only. */
export function isPosOnlyAllowedPath(pathname) {
  if (!pathname) return false;
  if (pathname === '/pos' || pathname.startsWith('/pos/')) return true;
  if (pathname === '/pos-v2' || pathname.startsWith('/pos-v2')) return true;
  return false;
}

export function getRoleLabel(user) {
  if (isPosOnlyUser(user)) return 'Absent · POS';
  const mr = resolveMagasinRole(user);
  const map = {
    super_admin: 'Directeur',
    admin_magasin: 'Resp. magasin',
    vendeur: 'Vendeur',
    technicien: 'Technicien',
  };
  return map[mr] || user?.role || '';
}

export function isDirecteurView(user) {
  return resolveMagasinRole(user) === 'super_admin';
}

export function isResponsableView(user) {
  return resolveMagasinRole(user) === 'admin_magasin';
}

export function shouldShowCaisseInHeader(user) {
  const mr = resolveMagasinRole(user);
  return mr !== 'technicien';
}
